{
  "chart": {
    "how-to-measure": "Come misurare",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Seleziona la tua taglia, ti avviseremo quando sarà di nuovo disponibile"
  },
  "page": {
    "plans": {
      "try-now": "Prova ora",
      "what-included": "Cosa è incluso?",
      "popular-plan": "Popolare"
    },
    "about-us": {
      "title": "Chi siamo",
      "intro": "Goodchart è nata nel 2023 con la missione di trasformare la tua esperienza di acquisto di abbigliamento. Il nostro team di appassionati di moda, designer ed esperti tecnologici è qui per aiutarti a trovare capi che valorizzino davvero il tuo corpo. Grazie alla nostra interfaccia intuitiva e ai nostri algoritmi avanzati, offriamo consigli personalizzati basati sulle tue misure, sul tuo stile e sul tuo stile di vita.",
      "community": "Di' addio ai compromessi e dai il benvenuto a fiducia e comfort. Unisciti alla nostra comunità inclusiva di clienti soddisfatti e intraprendi un viaggio di shopping pieno di gioia con Goodchart.",
      "tagline": "Libera il tuo stile. Vivi la pura euforia della moda.",
      "founders": "Fondatori",
      "cedric-photo-alt": "Cedric, co-fondatore di Goodchart e responsabile prodotto",
      "nick-photo-alt": "Nick, co-fondatore di Goodchart e direttore operativo",
      "quentin-photo-alt": "Quentin, responsabile IT di Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Co-fondatore di Goodchart e responsabile prodotto",
      "nick": "Nick",
      "nick-role": "Co-fondatore di Goodchart e direttore operativo",
      "quentin": "Quentin",
      "quentin-role": "Responsabile IT di Goodchart"
    },
    "contact": {
      "title": "Contattaci",
      "lets-talk": "Parliamone",
      "subtitle": "Compila il modulo e il nostro team ti contatterà via email.",
      "first-name": "Nome",
      "first-name-required": "Il nome è obbligatorio",
      "last-name": "Cognome",
      "last-name-required": "Il cognome è obbligatorio",
      "email": "Email",
      "email-required": "L'email è obbligatoria",
      "email-invalid": "Inserisci un indirizzo email valido",
      "message": "Messaggio",
      "message-required": "Il messaggio è obbligatorio",
      "sending": "Invio in corso...",
      "send": "Invia",
      "success": "Il tuo modulo è stato inviato al nostro team!"
    },
    "email-unsubscribe": {
      "title": "Iscrizione email",
      "unsubscribe-confirm": "Sei sicuro di volerti disiscrivere dalla nostra newsletter?",
      "unsubscribe-info": "Disiscrivendoti, non riceverai più aggiornamenti, newsletter e offerte speciali da parte nostra.",
      "cancel": "Annulla",
      "confirm-unsubscription": "Conferma disiscrizione",
      "resubscribe-confirm": "Vuoi iscriverti nuovamente alla nostra newsletter?",
      "resubscribe-info": "Resta aggiornato con le nostre ultime notizie, offerte esclusive e novità interessanti.",
      "resubscribe": "Iscriviti di nuovo",
      "unsubscribe-success": "Disiscrizione della tua email avvenuta con successo",
      "unsubscribe-error": "Si è verificato un problema durante la disiscrizione della tua email",
      "resubscribe-success": "Reiscrizione della tua email avvenuta con successo",
      "resubscribe-error": "Si è verificato un problema durante la reiscrizione della tua email"
    },
    "back-to-stock": {
      "notify-me-product": "Avvisami per il prodotto {{title}} - {{variant}}"
    },
    "help": {
      "title": "Centro assistenza",
      "description": "Guide per configurare e usare Goodchart nel tuo negozio Shopify.",
      "search": "Cerca negli articoli di aiuto",
      "loading": "Caricamento…",
      "load-failed": "Impossibile caricare il centro assistenza. Riprova tra un momento.",
      "no-results": "Nessun articolo corrisponde alla tua ricerca.",
      "no-articles": "Non ci sono ancora articoli di aiuto.",
      "topics": {
        "getting-started": "Per iniziare",
        "size-charts": "Guide alle taglie",
        "table-charts": "Tabelle",
        "assigning-products": "Assegnare i prodotti",
        "storefront-display": "Visualizzazione nel negozio",
        "chart-import": "Importazione delle guide",
        "size-recommendations": "Consigli sulla taglia",
        "plans-billing": "Piani e fatturazione",
        "troubleshooting": "Risoluzione dei problemi"
      },
      "back": "Torna al centro assistenza",
      "browse": "Vai al centro assistenza",
      "not-found": {
        "title": "Articolo non trovato",
        "description": "Questo articolo non esiste o non è più disponibile."
      },
      "updated": "Ultimo aggiornamento: {{date}}",
      "related": "Altro su {{topic}}",
      "contact": {
        "title": "Hai ancora bisogno di aiuto?",
        "description": "Inviaci un messaggio e il nostro team ti risponderà via email. Se hai installato l'app Goodchart, puoi chiedere anche nella sua chat di assistenza.",
        "link": "Contattaci"
      },
      "article-load-failed": "Impossibile caricare questo articolo. Riprova tra un momento."
    }
  },
  "error": {
    "error-occurred": "Si è verificato un errore!",
    "failed-to-subscribe-to-this-product": "Impossibile iscriversi a questo prodotto!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Impossibile ottenere il tuo consiglio sulla taglia. Riprova più tardi."
  },
  "common": {
    "close": "Chiudi"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Trova la tua taglia migliore",
        "subtitle": "Alcuni dettagli rapidi per una vestibilità migliore",
        "shopping-for": "ACQUISTI PER",
        "gender-women": "Donna",
        "gender-men": "Uomo",
        "gender-other": "Altro",
        "measurements": "MISURE",
        "height": "Altezza",
        "height-required": "L'altezza è obbligatoria",
        "height-min": "L'altezza minima è 1",
        "weight": "Peso",
        "weight-required": "Il peso è obbligatorio",
        "weight-min": "Il peso minimo è 1",
        "preferred-fit": "Vestibilità preferita",
        "continue": "Continua"
      },
      "result": {
        "suggested-size": "Taglia suggerita:",
        "no-fit": "Purtroppo sembra che al momento non abbiamo una taglia ideale. Ti consigliamo di controllare più tardi per ulteriori opzioni.",
        "verdict": "Verdetto:",
        "similar-variants": "Varianti simili:",
        "proceed": "Procedi con questa variante",
        "estimate-disclaimer": "(Stima basata sul brand e sulle informazioni dell'utente, i risultati possono variare.)",
        "back": "Indietro"
      }
    },
    "footer": {
      "terms": "Termini",
      "privacy": "Privacy",
      "help-center": "Centro assistenza",
      "blog": "Blog",
      "about": "Chi siamo",
      "contact-us": "Contattaci"
    },
    "conversion-table": {
      "description": "A seconda della vestibilità, potrebbero apparire lievi differenze nelle misure. Trova la tua taglia corretta nella tabella qui sotto.",
      "size": "Taglia"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Avvisami quando disponibile",
      "notify-me": "Avvisami",
      "out-of-stock": "Esaurito"
    },
    "restock-form": {
      "your-name": "Il tuo nome",
      "your-email": "Il tuo indirizzo email",
      "email-required": "L'email è obbligatoria",
      "subscribing": "Iscrizione in corso...",
      "notify-me": "AVVISAMI",
      "agree-terms": "Continuando, accetti i nostri",
      "terms-privacy": "Termini e la politica sulla privacy",
      "news-opt-in": "Vorrei ricevere aggiornamenti su nuovi lanci e altri contenuti ispirazionali (facoltativo)"
    },
    "back-to-stock-result": {
      "new-subscription": "Grazie, ti invieremo un'email quando la taglia <span class=\"font-bold\">{{name}}</span> sarà disponibile.",
      "existing-subscription": "Abbiamo la tua email! Ti avviseremo non appena la taglia <span class=\"font-bold\">{{name}}</span> sarà di nuovo disponibile.",
      "back-to-collection": "Torna alla collezione"
    },
    "chart": {
      "find-your-size": "Trova la tua taglia",
      "size-guide": "Guida alle taglie",
      "recommendation": "Consiglio",
      "body-measurements": "MISURE CORPOREE",
      "model-measurements": "MISURE DEL MODELLO",
      "model-description": "Il modello {{name}} è alto {{height}}cm e indossa la taglia {{variant}}.",
      "size-conversion": "CONVERSIONE TAGLIE"
    },
    "landing": {
      "learn": "Scopri",
      "learn-more": "Scopri di più",
      "blog": "Blog",
      "blog-description": "Esplora i nostri ultimi annunci, aggiornamenti dei prodotti e altro ancora",
      "help-center": "Centro assistenza",
      "help-center-description": "Guida introduttiva, tutorial e istruzioni passo dopo passo",
      "demo": "Demo",
      "demo-description": "Guarda i widget Goodsize in azione nel nostro negozio dimostrativo",
      "services": "SERVIZI",
      "contact": "Contatto",
      "privacy": "Privacy",
      "goodsize": "Goodsize",
      "goodsize-description": "Scopri la nostra soluzione di vestibilità per la tua attività",
      "goodchart": "Goodchart",
      "goodchart-description": "Tabella taglie visiva per aumentare la conversione"
    },
    "product-variant-completer": {
      "title": "Scegli le tue opzioni",
      "body": "Seleziona la tua {{option}} per continuare.",
      "body-multiple": "Seleziona le opzioni rimanenti per continuare.",
      "body-notify": "Quale {{option}} dobbiamo tenere d'occhio per te?",
      "confirm": "Continua",
      "cancel": "Annulla",
      "empty": "Questa combinazione non è disponibile."
    },
    "checkout-variant": {
      "label": "Stai acquistando {{variant}}",
      "aria-label": "Cambia la variante che stai acquistando",
      "sold-out": "esaurito"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
